import { useUser } from '@cobliteam/hooks';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import type React from 'react';
import { useCallback, useEffect, useState } from 'react';

import LoadingPage from '../pages/LoadingPage';

interface FeatureFlagsProviderProps {
  children: React.ReactNode;
}

const FeatureFlagsProvider = ({ children }: FeatureFlagsProviderProps) => {
  const ldClient = useLDClient();
  const [initialized, setInitialized] = useState(false);

  const { session, useGetUserData } = useUser();
  const { data: user } = useGetUserData(session?.user.id, !!session);

  const ldClientIdentify = useCallback(async () => {
    if (ldClient && user && session) {
      // Get the previous context before calling identify

      await ldClient.identify({
        kind: 'multi',
        user: {
          key: session.user.email,
          id: session.user.id,
          fleet_name: session.fleet.name,
          fleet_id: session.fleet.id,
          num_devices: user.userAttributes.numberOfDevices,
          creation_date: user.userAttributes.creationDate,
          age_in_days: user.userAttributes.ageInDays,
        },
        fleet: {
          key: session.fleet.id,
          name: session.fleet.name,
          num_devices: user.userAttributes.numberOfDevices,
        },
      });

      setInitialized(true);
    }
  }, [ldClient, user, session]);

  useEffect(() => {
    ldClientIdentify();
  }, [ldClientIdentify]);

  if (!initialized) return <LoadingPage showLogo message='Carregando configurações do sistema...' />;

  return children;
};

export default FeatureFlagsProvider;
